import { UpdateCampaignBillingRequest, UpdateCampaignBillingResponse } from '../../api-models';
import { UpdatedCampaignBilling } from '../../types/campaigns.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostUpdateCampaignBilling extends BaseAdapter<UpdateCampaignBillingResponse> implements AdapterInterface {
  rawResponse: UpdateCampaignBillingResponse;

  modifiedRequest: UpdateCampaignBillingRequest;

  async adaptResponse(request: {
    organisationDisplayName: string,
    isCampaignEnabled: boolean | null,
    channelName: string | null,
    changeAmount: number | null
  }): Promise<UpdatedCampaignBilling> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/update-campaign-billing', HTTPMethod.Post, formattedRequest);
    return this.displayResponse();
  }

  async displayResponse(): Promise<UpdatedCampaignBilling> {
    return {
      organisationDisplayName: this.rawResponse.organisation_display_name,
      isCampaignEnabled: this.rawResponse.is_campaign_enabled,
      channelName: this.rawResponse.channel_name,
      updatedAmount: this.rawResponse.updated_amount,
    };
  }

  adaptRequest(request: {
    organisationDisplayName: string,
    isCampaignEnabled: boolean | null,
    channelName: string | null,
    changeAmount: number | null
  }): UpdateCampaignBillingRequest {
    this.modifiedRequest = {
      organisation_display_name: request.organisationDisplayName,
      is_campaign_enabled: request.isCampaignEnabled,
      channel_name: request.channelName,
      change_amount: request.changeAmount,
    };
    return this.modifiedRequest;
  }
}
